import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_bestsellers: FaireCollectionEntity = {
  token: "col_bestsellers",
  type: "collection",
  name: "Bestsellers",
  description: "Our most popular products loved by retailers.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  season: "special",
  itemCount: 48,
  isSpecial: true,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
